import styles from "./Discussion.module.css";

export const Discussion = () => {
	return <div>Discussion</div>;
};
